import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 12px;
  flex: 1;
  border: 1px solid #c0c0c0;
`;

export const Button: any = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  height: 50px;
  border-radius: 12px;
  background-color: ${(props: any) => (props?.isActive ? "#02de7f" : "#fff")};
  flex: 1;
  cursor: pointer;
`;

export const ButtonText: any = styled.p`
  color: ${(props: any) => (props?.isActive ? "#fff" : "#333333")};
`;
